import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
}                     from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Alert,
  AlertTitle,
} from '@material-ui/lab';

import {
  startResource as startCrawl,
}                     from  '../../resource/hooks';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function DatasetActionStartCrawl(props) {
  const { dataset, open, onClose } = props;

  const [startCrawlStatus, setStartCrawlStatus] = React.useState(null);
  const [startCrawlMessage, setStartCrawlMessage] = React.useState(null);

  const classes = useStyles();

  const handleClose = () => {
    setStartCrawlStatus(null);
    setStartCrawlMessage(null);
    if(onClose) {
      onClose();
    }
  };

  const handleStartCrawl = async () => {
    setStartCrawlStatus('STARTING');
    doStartCrawl(dataset.ResourceId);
  };
  
  const doStartCrawl = async (datasetId) => {
    const { succeeded, error } = await startCrawl(datasetId);
    if(succeeded) {
      setStartCrawlStatus('STARTED');
    } else {
      setStartCrawlStatus('FAILED');
      setStartCrawlMessage(error);
    }
  };
  
  return(
    <Dialog
      className={classes.root}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {startCrawlStatus==='STARTING'?
      <Alert severity="info">
        <AlertTitle>Starting</AlertTitle>
        Start crawl requested... <strong>please wait!</strong>
      </Alert>
      :startCrawlStatus==='STARTED'?
      <Alert severity="success" onClose={onClose}>
        <AlertTitle>Success</AlertTitle>
        Crawl was started successfully
      </Alert>
      :startCrawlStatus==='FAILED'?
      <Alert severity="error" onClose={onClose}>
        <AlertTitle>Error</AlertTitle>
        An error occurred starting crawl: {startCrawlMessage}
      </Alert>
      :
      <React.Fragment>
        <DialogTitle id="alert-dialog-title">
          Start Crawl?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="prompt">
            Are you sure you want to start a crawl on dataset?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleStartCrawl} color="primary" autoFocus>
            Start
          </Button>
        </DialogActions>
      </React.Fragment>
      }
    </Dialog>
  );
}

DatasetActionStartCrawl.propTypes = {
  dataset: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

DatasetActionStartCrawl.defaultProps = {
  open: true,
};